import { ColumnPlainObject } from './column.plainObject';
import { TransformPlainObject } from './transform.plainObject';

export class SurrogateKeyPlainObject extends TransformPlainObject {
    public keyColumn: ColumnPlainObject;
}
